module.exports = __webpack_public_path__ + "img/27.6e0294f1.svg";